import {
    IM_DFM_RESET,
    IM_DFM_SET_ACTIVE_SLIDE_ID,
    IM_DFM_SET_SHOULD_SYNC,
    IM_DFM_SET_SLIDES,
    IM_DFM_UPDATE_SLIDE,
} from './constants'
import { ImDfmStateType } from './types'
import {
    resetImDfmState,
    setActiveSlideId,
    setImDfmSlides,
    setShouldSync,
    updateImDfmSlide,
} from './actions'

export const initialState: ImDfmStateType = {
    activeSlideId: null,
    slides: [],
    shouldSync: true,
}

type ActionType =
    | ReturnType<typeof setActiveSlideId>
    | ReturnType<typeof setImDfmSlides>
    | ReturnType<typeof resetImDfmState>
    | ReturnType<typeof setShouldSync>
    | ReturnType<typeof updateImDfmSlide>

const imDfmSlidesReducer = (
    state: ImDfmStateType = initialState,
    action: ActionType,
) => {
    switch (action.type) {
        case IM_DFM_RESET: {
            return { ...initialState }
        }

        case IM_DFM_SET_ACTIVE_SLIDE_ID: {
            return {
                ...state,
                activeSlideId: action.slideId,
            }
        }

        case IM_DFM_SET_SLIDES: {
            return {
                ...state,
                slides: action.slides,
            }
        }

        case IM_DFM_SET_SHOULD_SYNC: {
            return {
                ...state,
                shouldSync: action.shouldSync,
            }
        }

        case IM_DFM_UPDATE_SLIDE: {
            const existingSlideIndex = state.slides.findIndex(
                slide => slide.id === action?.slideData?.id,
            )

            if (existingSlideIndex === -1) {
                return state
            }

            return {
                ...state,
                slides: [
                    ...state.slides.slice(0, existingSlideIndex),
                    {
                        ...state.slides[existingSlideIndex],
                        ...action.slideData,
                    },
                    ...state.slides.slice(existingSlideIndex + 1),
                ],
            }
        }

        default:
            return state
    }
}

export default imDfmSlidesReducer
